<!-- ConsumablesSet.vue -->
<template>
  <div class="w-full min-h-screen bg-gray-50 flex flex-col">
    <!-- Header -->
    <div
      class="flex justify-between items-center bg-white border-b px-6 py-4 shadow-sm"
    >
      <h1 class="text-xl md:text-2xl font-semibold text-gray-800">
        Consumables for: {{ service }}
      </h1>
      <button
        @click="showConModal"
        class="bg-blue-600 font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition"
      >
        + Add Consumable
      </button>
    </div>

    <!-- Content -->
    <div class="flex-1 px-6 py-6">
      <!-- Loading -->
      <div
        v-if="loading"
        class="flex flex-col items-center justify-center py-20 text-gray-500"
      >
        <div
          class="animate-spin w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full"
        ></div>
        <p class="mt-4 text-sm">Loading consumables...</p>
      </div>

      <!-- Error -->
      <div v-else-if="error" class="text-center py-20">
        <p class="text-red-600 font-medium">Error: {{ error }}</p>
        <p class="text-gray-500 text-sm mt-2">Please reload the page.</p>
      </div>

      <!-- Table -->
      <div v-else class="bg-white rounded-lg border shadow-sm overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-700">
          <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
            <tr>
              <th class="px-4 py-3">Item Name</th>
              <th class="px-4 py-3">Quantity</th>
              <th class="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="consumables.length === 0">
              <td colspan="3" class="px-4 py-6 text-center text-gray-500">
                No consumables found for this service.
              </td>
            </tr>
            <tr
              v-for="item in consumables"
              :key="item.id"
              class="hover:bg-gray-50"
            >
              <td class="px-4 py-3 font-medium">
                <ItemName
                  :ItemName="item.item_name"
                  :ItemBrand="item.brand_name"
                  :ItemStrength="item.item_strength"
                />
              </td>
              <td class="px-4 py-3">{{ item.quantity }}</td>
              <td class="px-4 py-3 text-right">
                <button
                  @click="deleteConsumable(item.id)"
                  class="text-red-600 hover:text-red-700 text-sm font-medium"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <AddConsumableModal
    :serviceIdentity="serviceId"
    v-if="showingConModal"
    @close="closeConMod"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import AddConsumableModal from "./modals/add_consumables_modal.vue";
import ItemName from "./components/ItemName.vue";
export default {
  name: "ConsumablesSet",
  data() {
    return {
      showingConModal: false,
      service: null,
      serviceId: this.$route.params.serciceID,
      consumables: [],
      showModal: false,
      newItem: { item_name: "", quantity: null },
      loading: true,
      error: null,
    };
  },
  components: {
    AddConsumableModal,
    ItemName,
  },
  methods: {
    showConModal() {
      this.showingConModal = true;
    },
    closeConMod() {
      this.showingConModal = false;
      window.location.reload();
    },
    async fetchConsumables() {
      this.loading = false;

      const url = "consumables/by_service/" + this.serviceId;
      const body = {};
      const data = await generalApiRequest(url, "GET", body, 1);

      this.consumables = data.consumables;
      this.service = data.service.name;
      // console.log(data.service.name);
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.newItem = { item_name: "", quantity: null };
    },
    addConsumable() {
      const newId =
        this.consumables.length > 0
          ? Math.max(...this.consumables.map((i) => i.id)) + 1
          : 1;
      this.consumables.push({ ...this.newItem, id: newId });
      this.closeModal();
    },
    async deleteConsumable(id) {
      const url = "consumables/" + id;
      const body = {};
      const data = await generalApiRequest(url, "POST", body, 1);
      if (data) {
        window.location.reload();
      }
    },
  },
  mounted() {
    this.fetchConsumables();
  },
};
</script>
